export default __webpack_public_path__ + "static/media/ambiente-latino-NC.13e3f670.svg";